<template>
  <div class="homepage-component hp-content-on-image" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="background-img flex-row text-center align-items-center justify-content-center" :style="{backgroundImage: contentImg}">
      <h2 class="animation-element bounce-up-slow secondary-color-white kia-sokal-bottom in-view">
        Welcome to <span class="coi-text-adjust">Hometown {{ brandName }}</span>
      </h2>
      <h3 class="animation-element bounce-up-slow reveal2 secondary-color-white kia-sokal-top in-view">Proud to be one of the leading dealerships in City, ST.
      </h3>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['images'],
    data() {
      return {
        brand: this.$store.state.chosenBrand,
      }
    },
    computed: {
      brandName () {
        if (this.brand === 'none') {
          return 'Dealer';
        } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
          return this.brand.toUpperCase();
        } else {
          return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
        }
      },
      contentImg () {
        if (this.brand === 'kia' || this.brand === 'cjdr' || this.brand === 'infiniti') {
          return 'url(' + this.images.lifestyleImages.defaultImage + ')';
        } else if (this.brand === 'none' || this.brand === 'honda') {
          return 'url(' + this.images.lifestyleImages.sedanImage + ')';
        } else if (this.brand === 'chevrolet' || this.brand === 'nissan' || this.brand === 'ford') {
          return 'url(' + this.images.lifestyleImages.truckImage + ')';
        } else {
          return 'url(' + this.images.lifestyleImages.suvImage + ')';
        }
      }
    }
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.hp-content-on-image {
  background-color: #888b8d;
}
.hp-content-on-image .background-img {
  background-position: center center;
  background-size: auto;
  background-repeat: no-repeat;
  background-color: #697279;
  background-blend-mode: multiply;
  padding: 12vw;
}
.hp-content-on-image h2, .hp-content-on-image h3 {
  color: #fff;
}
.hp-content-on-image .kia-sokal-top {
  font-weight: 400;
  font-size: 5rem;
}
.hp-content-on-image .kia-sokal-bottom {
  font-weight: 600;
  font-size: 8rem;
}
@media (min-width: 768px) and (max-width: 1200px) {
  .hp-content-on-image .background-img {
    background-position: 70%;
    padding: 25vw 5vw;
  }
  .hp-content-on-image .kia-sokal-top {
    font-size: 4rem;
}
.hp-content-on-image .kia-sokal-bottom {
    font-size: 6rem;
  }
}
@media (max-width:767px) {
  .hp-content-on-image .background-img {
    background-position: 70%;
    padding: 45vw 15px;
  }
  .hp-content-on-image .kia-sokal-top {
    font-size: 3rem;
  }
  .hp-content-on-image .kia-sokal-bottom {
    font-size: 5rem;
  }
}
@media (max-width:575px) {
  .hp-content-on-image .kia-sokal-top {
    font-size: 2.4rem;
    margin-top: 30px;
  }
  .hp-content-on-image .kia-sokal-bottom {
    font-size: 4rem;
  }
}

/* Brands */
.hp-content-on-image[data-brand="chevrolet"] .kia-sokal-bottom {
  font-size: 7rem;
}
.hp-content-on-image[data-brand="chevrolet"] .kia-sokal-top {
  font-family: Louis-Regular, 'Louis-Regular', 'Roboto', sans-serif !important;
  font-size: 4.5rem;
}
.hp-content-on-image[data-brand="cjdr"] .kia-sokal-bottom {
  font-size: 7.5rem;
}
.hp-content-on-image[data-brand="ford"] .kia-sokal-top {
  font-family: FordAntenna-Regular, 'FordAntenna-Regular', 'Helvetica Neue', Arial, sans-serif !important;
}
.hp-content-on-image[data-brand="hyundai"] .kia-sokal-bottom {
  font-size: 7.5rem;
}
.hp-content-on-image[data-brand="hyundai"] .kia-sokal-top {
  font-family: Hyundai-Regular, 'Hyundai-Regular', 'Helvetica Neue', Arial, sans-serif !important;
}
.hp-content-on-image[data-brand="infiniti"] .kia-sokal-bottom {
  text-transform: uppercase;
  font-size: 7rem;
}
.hp-content-on-image[data-brand="infiniti"] .kia-sokal-top {
  font-family: Infiniti-Regular, 'Infiniti-Regular', Arial, sans-serif !important;
}
.hp-content-on-image[data-brand="kia"] .kia-sokal-top {
  font-size: 4.5rem;
}
.hp-content-on-image[data-brand="lincoln"] .kia-sokal-bottom {
  font-family: LincolnProximaNova-Bold, 'LincolnProximaNova-Bold', Arial, sans-serif !important;
}
.hp-content-on-image[data-brand="lincoln"] .kia-sokal-top {
  font-family: LincolnProximaNova-Regular, 'LincolnProximaNova-Regular', Arial, sans-serif !important;
}
.hp-content-on-image[data-brand="mitsubishi"] .kia-sokal-bottom {
  font-size: 7.2rem;
}
.hp-content-on-image[data-brand="nissan"] .kia-sokal-top {
  font-family: NissanBrand-Regular, 'NissanBrand-Regular', Verdana, Arial, sans-serif !important;
  font-size: 4.7rem;
}
.hp-content-on-image[data-brand="toyota"] .kia-sokal-top {
  font-family: ToyotaType-Book, 'ToyotaType-Book', 'Helvetica Neue', Arial, sans-serif !important;
}
</style>